import styled from 'styled-components';

export const CancelRightMainWrap = styled.div(
    props => `
        width:30%;
        display: flex;
        flex-direction: column;
    `
);

export const CancelRightBlockHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.dark74};
    `
);

export const RightBlockInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        margin-top: ${props.theme.spacing.large.l20};
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 3px 2px -2px rgba(0, 0, 0, 0.07), 0 1px 5px 0 rgba(74, 74, 74, 0.2), 0 2px 2px 0 rgba(74, 74, 74, 0.2);
        background-color: ${props.theme.colors.white.base};
    `
);

export const BlockHtlImg = styled.img(
    props => `
        width:100%;
        display: flex;
        height: 10rem;
        border-radius: ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0 0;
    `
);

export const BlockHtlRoomInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l15};
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    `
);

export const BlockHtlNameText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `
);

export const BlockHtlRoomTypeWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        padding-top: ${props.theme.spacing.base};
    `
);

export const BlockRoomTypeImg = styled.div(
    props => `
        width:2.4rem;
        height: 2.4rem;
        margin-right: ${props.theme.spacing.base};
    `
);

export const BlockRoomTypeText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
    `
);

export const BlockPriceInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;   
    `
);

export const PriceBreakUpInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
        background-color: ${props.theme.colors.grey.lightf9};
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
        font-size: ${props.fs || props.theme.font.large.font14};
        font-weight: ${props.fw || props.theme.font.fontWeight.bold};
        color: ${props.color || props.theme.colors.grey.dark74};
    `
);

export const PriceBreakUpTextWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: ${props.theme.colors.grey.lightf9};
        font-size: ${props.theme.font.large.font12};
        color: ${props.theme.colors.grey.base};
    `
);

export const PriceBreakUpSubText = styled(PriceBreakUpTextWrap)(
    props => `
      padding: 0;
    `
);

export const PrcieBreakUpText = styled.p(
    props => `
        // font-size: ${props.theme.font.large.font14};
        // color: ${props.theme.colors.grey.dark74};
    `
);

export const PrcieBreakUpAmount = styled.p(
    props => `
      text-align: right;
    `
);

export const PrcieBreakUpSubAmount = styled(PrcieBreakUpAmount)(
    props => `
      width: 100%;
      color: ${props.theme.colors.grey.base1};
    `
);

export const PrcieRefundText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.green.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const PrcieRefundAmount = styled.p(
    props => `
        font-size: ${props.theme.font.large.font20};
        color: ${props.theme.colors.green.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-align: right;
    `
);

export const RefundBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l25};
    `
);

export const RefundBtn = styled.button(
    props => `
        outline: none;
        width:100%;
        border: none;
        border-radius: 3px;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
    `
);

export const RefundInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.dark74};
        padding-top: ${props.theme.spacing.large.l15};
        text-align: center;
    `
);